module.exports = "//static.hsappstatic.net/ComposeUI/static-1.9550/img/welcome@2x.png"